
import { Drawer, Table, Stack, FormControl, Avatar, RadioGroup, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Divider, Grid, Typography, Tooltip, IconButton, Autocomplete, TextField, InputAdornment, useTheme, FormControlLabel, Button, Toolbar, Radio, } from "@mui/material";

import { styled } from '@mui/material/styles';

import React, { useState, useEffect, useRef } from "react";

import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";

import { AddCircleOutline, SaveAltOutlined, } from '@mui/icons-material';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import Cancel from '@mui/icons-material/CancelOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import { addDays } from "date-fns";


import CallAlertBar from "../../../Layout/Alertbar";
import PurchaseActionMenu from "./PurchaseOrderSubMenu";
import AddNewPurchaseReceive from "../receives/AddPurchaseReceives";


import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';


import jsPDF from 'jspdf';
import AddNewPurchaseBills from "../bill/AddPurchaseBill";
import FileUploadButton from "../../../Layout/fileupload";
import PreviewEmailModal from "../order/PreviewEmail";

import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import HorizonPO from "../reports/PurchaseOrderReport";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import useLoadVendorDetailById from "../../../hooks/useVendorGetDetailByID";
import useLoadCompanyDetailById from "../../../hooks/useLoadCompanyDetail";
import PurchaseOrderTimeline from "../order/PurchaseOrderTimeline";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import CustomAutocomplete from "../../../pages/commancomponents/customAutoComplete";
// import PaymentTermForm from "../../../components/PaymentTermsAdd";
import { createFilterOptions } from '@mui/material/Autocomplete';
import AddPaymentTerms from "../../master/AddPaymentTerms";
// import AddPaymentTerms from "../../../pages/productionmanagement/master/Add-Payment-Terms";
const filter = createFilterOptions();

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};






const AddNewPurchaseOrder = ({ handlecallback, editPurchaseOrderNumber, vendor_details, purchase_indent_no, selectedVendoIdListID }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = useState(false);

  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
  const [isPaymentTermDialogOpen, setPaymentTermDialogOpen] = useState(false);
  const callError = (serverityval, msg, title) => {
    // Update state with error message        
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };

  // load vendor hooks concept
  const { vendorDetails, loadVendorDetail } = useLoadVendorDetailById();
  const { companyDetails, } = useLoadCompanyDetailById();


  const callback = () => {
    handlecallback();
  }

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
  ))({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: colors.blueAccent[500],
      color: 'white',
      fontSize: '14px',
      borderRadius: '10px',
      padding: '10px',

    },
    [`& .MuiTooltip-arrow`]: {
      color: colors.blueAccent[500],
    },
  });

  const [orderFromDate, setOrderFromDate] = useState(dayjs());
  const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(dayjs(addDays + 15));

  // multiple selection options

  const [paymentTerms, setPaymentTerms] = useState([]);
  const [paymentTermAnchorEl, setPaymentTermAnchorEl] = useState(null);
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);
  const [paymentTermFilterText, setPaymentTermFilterText] = useState('');
  const [paymentTermsID, setPaymentTermsID] = useState(0);
  const [isPaymentTermsLoaded, setIsPaymentTermsLoaded] = useState(false);
  const [payment_days, setPaymentTermsDays] = useState([]);

  // List of Parameter
  const [selectedPartyID, setSelectedPartyID] = useState(0);
  const [selectedParty, setSelectedParty] = useState(null);

  const [referenceNumber, setReferenceNumber] = useState('');
  const [shipmentReferenceNumber, setShipmentReferenceNumber] = useState('');
  const [customerNotes, setCustomerNotes] = useState('');
  const [subTotal, setSubTotal] = useState(0);
  const [discountID, setDiscountID] = useState(0);
  const [tcsID, setTCSID] = useState(0);
  const [termsConditions, setTermsConditions] = useState('');
  const [freight, setFreight] = useState(null);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);


  const [isLoadEditPO, setLoadEditPO] = useState(false);
  const [rows, setRows] = useState([{ id: 1, product: '', productId: 0, account: null, accountId: 0, quantity: 1, rate: 0.0, tax: 0.0, amount: 0.0, cgst_rate: 0.0, cgst_amount: 0.0, sgst_rate: 0.0, sgst_amount: 0.0, igst_rate: 0.0, igst_amount: 0.0, additional_info: '', total: 0.0 }]);


  const [poNumber, setPONumber] = useState([]);
  const [isPONumberLoaded, setIsPONumberLoaded] = useState(false);

  const [products, setProduct] = useState([]);
  const [isProductsLoaded, setIsProductLoaded] = useState(false);

  const [selectedButtonName, setSelectedButtonName] = useState('');
  const [viewPurchaseOrder, setViewPurchaseOrder] = useState(true);
  const [viewPurchaseReceive, setViewPurchaseReceive] = useState(false);
  const [viewPurchaseBill, setViewPurchaseBill] = useState(false);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);


  const [discount, setDiscount] = useState(null);
  const [adjustment, setAdjustment] = useState(0);
  const [tcs, setTcs] = useState(null);

  const [tds, setTds] = useState(null);
  const [dTDS, setDTDS] = useState(0); // calculated TDS value
  const [tdsID, setTDSID] = useState(null); // if needed

  const [tcsOptions, settcsOptions] = useState([]);
  const [istcsOptions, setIstcsOptions] = useState(false);
  const [tdsOptions, settdsOptions] = useState([]);
  const [istdsOptions, setIstdsOptions] = useState(false);
  const [dDiscount, setDDiscount] = useState(0);
  const [dTCS, setDTCS] = useState(0);
  const [dadjustment, setDAdjustment] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [dCGST, setDCGST] = useState(0);
  const [dSGST, setDSGST] = useState(0);

  // get party list
  const [partyList, setPartyList] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [selectedValue, setSelectedValue] = useState('warehouses');
  const reportRef = useRef();
  const [viewPurchaseReport, setViewPurchaseReport] = useState(false);
  const [disableSaveBtn, setDisableSaveBtn] = useState(false);

  // File upload functions
  const [files, setFiles] = useState([]);
  const [fileCount, setFileCount] = useState(0);
  const [formData, setFormData] = useState({
    // Your other form fields
    // exampleField: '',
  });

  const [allPOData, setAllPOData] = useState({});
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [isPurchaseAccounts, setIsPurchaseAccounts] = useState(false);
  const [discounts, setDiscounts] = useState([]);
  const [isDiscounts, setIsDiscounts] = useState(false);

  useEffect(() => {
    if (!isProductsLoaded) {
      const para = {
        p_companyid: 13,
      }
      callApi(API_ENDPOINTS.PRODUCT_ITEM_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) { setProduct(data); }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [isProductsLoaded]);




  useEffect(() => {
    if (!isPurchaseAccounts) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_ACCOUNTS, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setPurchaseAccounts(data);
          }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [isPurchaseAccounts]);





  useEffect(() => {
    const fetchData = async () => {
      if (!isLoadEditPO && editPurchaseOrderNumber != 0) {
        try {
          const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            purchase_order_id: editPurchaseOrderNumber,
          };

          const purchaseOrderResponse = await callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PURCHASE_ORDER, 'POST', { 'Content-Type': 'application/json' }, para);
          const purchaseOrder = purchaseOrderResponse[0];

          const productPara = { p_companyid: 13 };
          const accountPara = { p_companyid: 13 };

          const [productsData, accountsData] = await Promise.all([
            callApi(API_ENDPOINTS.PRODUCT_ITEM_LIST, 'POST', { 'Content-Type': 'application/json' }, productPara),
            callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_ACCOUNTS, 'POST', { 'Content-Type': 'application/json' }, accountPara)
          ]);

          if (productsData && productsData.length > 0) setProduct(productsData);
          if (accountsData && accountsData.length > 0) setPurchaseAccounts(accountsData);

          if (purchaseOrder) {
            setPONumber(purchaseOrder.purchase_order_number);
            setReferenceNumber(purchaseOrder.reference);
            setShipmentReferenceNumber(purchaseOrder.shipment_reference);
            setSelectedPartyID(purchaseOrder.id_party);
            setPaymentTermsID(purchaseOrder.id_payment_terms);
            setPaymentTermsDays(purchaseOrder.payment_days);
            setOrderFromDate(purchaseOrder.po_date);
            setExpectedDeliveryDate(purchaseOrder.expiry_delivery_date);
            setCustomerNotes(purchaseOrder.customer_notes);
            setTermsConditions(purchaseOrder.terms_conditions);

            const productData = typeof purchaseOrder.product_list === 'string' ? JSON.parse(purchaseOrder.product_list) : purchaseOrder.product_list;

            const mappedRows = productData.map(item => ({
              ...item,
              product: productsData.find(p => p.id === item.productId) || '',
              account: accountsData.find(a => a.id === item.accountId) || '',
            }));

            setRows(Array.isArray(productData) ? mappedRows : []);

            updatePartyListAndSetSelectedParty(purchaseOrder.id_party);
            loadVendorDetail(purchaseOrder.id_party);
            updateTCSList(purchaseOrder.id_tcs);
            updateTDSList(purchaseOrder.id_tds);
            updateDiscountList(purchaseOrder.id_discount);
            setAdjustment(purchaseOrder.adjustment_value);
            setCgst(purchaseOrder.cgst);
            setSgst(purchaseOrder.sgst);
            setFreight(purchaseOrder.fright);

            updateFormData(mappedRows, purchaseOrder);
          }
        } catch (error) {
          callError('error', error.message, 'Error');
        }
      }
    };

    fetchData();
  }, [isLoadEditPO, editPurchaseOrderNumber]);



  useEffect(() => {
    if (vendor_details && products.length > 0 && purchaseAccounts.length > 0 && purchase_indent_no !== '') {

      setSelectedPartyID(vendor_details[0].id_party);
      updatePartyListAndSetSelectedParty(vendor_details[0].id_party);
      setExpectedDeliveryDate(vendor_details[0].delivery_date);
      setSelectedValue('customer');
      setReferenceNumber(purchase_indent_no);

      setFreight(vendor_details[0].fright || '');

      if (vendor_details[0]?.id_payment_terms && paymentTerms?.length) {
        const selectedTerm = paymentTerms.find(
          term => term.id === vendor_details[0].id_payment_terms
        );

        if (selectedTerm) {
          setPaymentTermsID(vendor_details[0].id_payment_terms);
          setSelectedPaymentTerm(selectedTerm);
        }
      }


      if (vendor_details[0]?.id_tds && tdsOptions?.length) {

        const selectedTds = tdsOptions.find(
          tds => tds.id === vendor_details[0].id_tds
        );

        if (selectedTds) {
          setTDSID(vendor_details[0].id_tds);
          setTds(selectedTds); // ✅ THIS is the fix
        }

      }

      if (vendor_details[0]?.id_discount && discounts?.length) {
        const selectedDiscount = discounts.find(
          tds => tds.id === vendor_details[0].id_discount
        );

        if (selectedDiscount) {
          setDiscountID(vendor_details[0].id_discount);
          setDiscount(selectedDiscount); // ✅ THIS is the fix
        }

      }



      const outputData = vendor_details.map((item, index) => ({
        id: index + 1,
        productId: item.id_material,
        accountId: 1, // or get from dropdown if needed
        quantity: item.selectedQty.toString(),
        rate: item.quoted_price.toString(),
        tax: 0,
        cgst_rate: item.cgst_rate,
        cgst_amount: item.cgst_amount,
        sgst_rate: item.sgst_rate,
        sgst_amount: item.sgst_amount,
        igst_rate: item.igst_rate,
        igst_amount: item.igst_amount,
        amount: item.selectedQty * item.quoted_price,
        total: parseFloat(
          (
            (item.selectedQty * item.quoted_price) +
            item.cgst_amount +
            item.sgst_amount +
            item.igst_amount
          ).toFixed(2)
        ),
      }));
      //total:parseFloat((item.selectedQty * item.quoted_price)+(item.cgst_amount)+(item.sgst_amount)+(item.igst_amount).toFixed(2)),
      // setRows(outputData);

      const mappedRows = outputData.map(item => ({
        ...item,
        product: products.find(p => p.id === item.productId) || '',
        account: purchaseAccounts.find(a => a.id === item.accountId) || '',
      }));

      setRows(Array.isArray(products) ? mappedRows : []);

    }
  }, [vendor_details, products, purchaseAccounts, tdsOptions, paymentTerms, discounts]);





  const updateFormData = (productData, purchaseOrder) => {
    const subtotal = productData.reduce((sum, item) => sum + item.amount, 0);
    const totalQuantity = productData.reduce((sum, item) => sum + item.quantity, 0);

    const formData = {
      partyName: purchaseOrder.company, // Update as per your requirement
      purchaseOrderNumber: purchaseOrder.purchase_order_number,
      referenceNumber: purchaseOrder.reference,
      date: dayjs(purchaseOrder.po_date).format('DD-MMM-YYYY'),
      expectedDeliveryDate: dayjs(purchaseOrder.expiry_delivery_date).format('DD-MMM-YYYY'),
      //paymentTerms: purchaseOrder.payment_description,
      //paymentTerms: purchaseOrder.payment_days, // Fetch from data if available
      paymentTerms: `${purchaseOrder.payment_days} Days`,
      shipmentPreference: purchaseOrder.shipment_reference,
      products: productData.map(item => ({
        code: item.product.code,
        description: item.product.description,
        material_uom: item.product.material_uom,
        account: item.account.description,
        quantity: item.quantity,
        rate: item.rate,
        amount: item.amount,
        cgst_rate: item.cgst_rate,
        cgst_amount: item.cgst_amount,
        sgst_rate: item.sgst_rate,
        sgst_amount: item.sgst_amount,
        igst_rate: item.igst_rate,
        igst_amount: item.igst_amount,
        total: item.total
      })),

      customerNotes: purchaseOrder.customer_notes,
      termsConditions: purchaseOrder.terms_conditions,
      subtotal: subtotal,
      totalQuantity: totalQuantity,
      discountPercentage: purchaseOrder.discount_percentage, // Fetch from data if available
      discountValue: purchaseOrder.discount_value,
      adjustment: purchaseOrder.adjustment_value,
      tcsPercentage: purchaseOrder.id_tcs, // Fetch from data if available
      tcsValue: purchaseOrder.tcs_value,
      tdsPercentage: purchaseOrder.id_tds,
      tdsValue: purchaseOrder.tds_value,
      cgstPercentage: purchaseOrder.cgst_percentage,
      cgst: purchaseOrder.cgst,
      sgstPercentage: purchaseOrder.sgst_percentage,
      sgst: purchaseOrder.sgst,
      total: subtotal - (subtotal * 0.05) + adjustment + (subtotal * 0.01), // Example calculation
      fright: purchaseOrder.fright,
    };
    setAllPOData(formData);

    // Generate PDF (example)
    // generatePDF(formData);


  };

  useEffect(() => {
    if (vendorDetails.length > 0) {
      const updatedPOData = {
        ...allPOData,
        supplier: vendorDetails,
        company: companyDetails

      }
      setAllPOData(updatedPOData);
      // }
      generatePDF();
    }
  }, [vendorDetails])




  const updatePartyListAndSetSelectedParty = (selectedPartyID) => {
    const para = {
      p_companyid: 1,
    }

    callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {
        if (data && data.length > 0) {
          setPartyList(data);
          const selected = data.find(party => party.id === selectedPartyID);
          if (selected) {
            setSelectedParty(selected);
          }
        }
      })
      .catch(error => {
        // handle error
        callError('error', error.message, 'Error');
      });
  };

  //TCS
  const updateTCSList = (selectedTCSID) => {
    const para = {
      p_companyid: 1,
    }
    callApi(API_ENDPOINTS.TCS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {

        if (data && data.length > 0) {
          settcsOptions(data);
          const selected = data.find(party => party.id === selectedTCSID);
          if (selected) {
            setTcs(selected);
            setTCSID(selectedTCSID);
          }
        }
      })
      .catch(error => { callError('error', error.message, 'Error'); });

  };

  // Discount
  const updateDiscountList = (selectedDiscountID) => {
    const para = {
      p_companyid: 1,
    }
    callApi(API_ENDPOINTS.DISCOUNT_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {

        if (data && data.length > 0) {
          setDiscounts(data);
          const selected = data.find(party => party.id === selectedDiscountID);
          if (selected) {
            setDiscount(selected);
            setDiscountID(selectedDiscountID);
          }
        }
      })
      .catch(error => { callError('error', error.message, 'Error'); });

  };

  const updateTDSList = (selectedTDSID) => {
    const para = {
      p_companyid: 1,
    }
    callApi(API_ENDPOINTS.TDS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
      .then(data => {

        if (data && data.length > 0) {
          settdsOptions(data);
          const selected = data.find(party => party.id === selectedTDSID);
          if (selected) {
            setTds(selected);
            setTDSID(selectedTDSID);
          }
        }
      })
      .catch(error => { callError('error', error.message, 'Error'); });

  };





  useEffect(() => {
    if (!isPaymentTermsLoaded) {
      const para = {
        p_companyid: 1,
        p_mode: 1
      }
      callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_PAYMENT_TERMS, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) { setPaymentTerms(data); }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [isPaymentTermsLoaded, isPaymentTermDialogOpen]);





  useEffect(() => {
    if (!isDiscounts) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.DISCOUNT_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setDiscounts(data);
          }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [isDiscounts]);




  useEffect(() => {
    if (!istcsOptions) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.TCS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            settcsOptions(data);
          }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [istcsOptions]);

  useEffect(() => {
    if (!istdsOptions) {
      const para = {
        p_companyid: 1,
      }
      callApi(API_ENDPOINTS.TDS_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            settdsOptions(data);
          }
        })
        .catch(error => { callError('error', error.message, 'Error'); });
    }
  }, [istdsOptions]);



  const handleOpenMenu = (setter) => (event) => {
    setter(event.currentTarget);
  };

  const handleCloseMenu = (setter) => () => {
    setter(null);
  };

  const handleSelectOption = (setSelectedOption, setSelectedID) => (option) => {
    setSelectedOption(option);
    setSelectedID(option ? option.id : null);
    handleCloseMenu();
  };




  const handleAddOption = (label) => () => {
    if (label === 'Payment Term') {
      setPaymentTermDialogOpen(true);
    }
  };


  const handleAddRow = () => {
    const newRowId = rows.length + 1;
    const newRow = { id: newRowId, product: '', productId: 0, account: null, accountId: 0, quantity: 1, rate: 0.0, tax: 0.0, amount: 0.0 };
    setRows([...rows, newRow]);
  };


  const removeRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1); // Remove the row at the specified index
    setRows(updatedRows);
  };


  const handleProductChange = (index, product) => {
    const newRows = [...rows];
    newRows[index].product = product;
    newRows[index].productId = product.id || '';
    newRows[index].rate = product ? product.rate : '';
    newRows[index].amount = product ? product.rate * (newRows[index].quantity || 1) : 0;
    setRows(newRows);

  };


  const calculateAmount = (quantity, rate, cgstRate, sgstRate, igstRate) => {
    const qty = parseFloat(quantity) || 0;
    const unitRate = parseFloat(rate) || 0;
    const base = qty * unitRate;

    const cgst = (base * (parseFloat(cgstRate) || 0)) / 100;
    const sgst = (base * (parseFloat(sgstRate) || 0)) / 100;
    const igst = (base * (parseFloat(igstRate) || 0)) / 100;

    return (base + cgst + sgst + igst).toFixed(2);
  };




  const handleQuantityChange = (index, quantity) => {
    const updatedRows = [...rows];
    const row = updatedRows[index];

    row.quantity = quantity;

    // Use existing rate and tax rates from the row
    const rate = parseFloat(row.rate) || 0;
    const cgstRate = parseFloat(row.cgst_rate) || 0;
    const sgstRate = parseFloat(row.sgst_rate) || 0;
    const igstRate = parseFloat(row.igst_rate) || 0;

    // Recalculate amount
    row.cgst_amount = ((row.amount * (parseFloat(row.cgst_rate) || 0)) / 100).toFixed(2);
    row.sgst_amount = ((row.amount * (parseFloat(row.sgst_rate) || 0)) / 100).toFixed(2);
    row.igst_amount = ((row.amount * (parseFloat(row.igst_rate) || 0)) / 100).toFixed(2);

    row.amount = (quantity * rate);
    row.amount = calculateAmount(quantity, rate, cgstRate, sgstRate, igstRate);

    setRows(updatedRows);
  };


  const handleTaxRateChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    const row = updatedRows[index];
    const amount = parseFloat(row.amount) || 0;

    row.cgst_amount = ((amount * (parseFloat(row.cgst_rate) || 0)) / 100).toFixed(2);
    row.sgst_amount = ((amount * (parseFloat(row.sgst_rate) || 0)) / 100).toFixed(2);
    row.igst_amount = ((amount * (parseFloat(row.igst_rate) || 0)) / 100).toFixed(2);

    const quantity = parseFloat(row.quantity) || 0;
    const rate = parseFloat(row.rate) || 0;

    row.amount = (quantity * rate);
    row.total = calculateAmount(quantity, rate, row.cgst_rate, row.sgst_rate, row.igst_rate);
    setRows(updatedRows);
  };


  const handleRateChange = (index, rate) => {
    const newRows = [...rows];
    newRows[index].rate = rate;
    newRows[index].amount = rate * (newRows[index].quantity || 1);

    const row = newRows[index];
    // Use existing rate and tax rates from the row
    const quantity = parseFloat(row.quantity) || 0;
    const cgstRate = parseFloat(row.cgst_rate) || 0;
    const sgstRate = parseFloat(row.sgst_rate) || 0;
    const igstRate = parseFloat(row.igst_rate) || 0;

    row.cgst_amount = ((row.amount * (parseFloat(row.cgst_rate) || 0)) / 100).toFixed(2);
    row.sgst_amount = ((row.amount * (parseFloat(row.sgst_rate) || 0)) / 100).toFixed(2);
    row.igst_amount = ((row.amount * (parseFloat(row.igst_rate) || 0)) / 100).toFixed(2);

    // Recalculate amount
    row.amount = (quantity * rate);
    row.total = calculateAmount(quantity, rate, cgstRate, sgstRate, igstRate);

    setRows(newRows);

  };

  const handleAccountChange = (index, account) => {
    const newRows = [...rows];
    newRows[index].account = account;
    newRows[index].accountId = account.id || '';
    setRows(newRows);

  };




  const calculateSubtotal = () => {
    return rows.reduce((total, row) => total + (parseFloat(row.amount) || 0), 0);
  };

  const calculateCgstTotal = () => {
    let total = rows.reduce((total, row) => total + (parseFloat(row.cgst_amount) || 0), 0);
    // setDCGST(total)
    return total;
  };

  const calculateSgstTotal = () => {
    return rows.reduce((total, row) => total + (parseFloat(row.sgst_amount) || 0), 0);
  };

  const calculateIgstTotal = () => {
    return rows.reduce((total, row) => total + (parseFloat(row.igst_amount) || 0), 0);
  };


  const calculateTotalQuantity = () => {
    return rows.reduce((total, row) => total + (parseInt(row.quantity, 10) || 0), 0);
  };




  useEffect(() => {
    const subtotal = calculateSubtotal();
    const discountValue = discount ? (discount.value / 100) * subtotal : 0;
    const tcsValue = tcs ? (tcs.value / 100) * subtotal : 0;
    const cgstValue = cgst ? (cgst / 100) * subtotal : 0;
    const sgstValue = sgst ? (sgst / 100) * subtotal : 0;
    const tdsValue = tds ? (tds.value / 100) * subtotal : 0;

    setSubTotal(subtotal);
    setDCGST(cgstValue);
    setDSGST(sgstValue);
    setDDiscount(discountValue);
    setDTCS(tcsValue);
    setDTDS(tdsValue);
    setDAdjustment(adjustment);
    setGrandTotal(subtotal - discountValue + parseFloat(adjustment || 0) + tcsValue - tdsValue);
  }, [rows, discount, adjustment, tcs, cgst, sgst, tds]);

  const calculateTotal = () => {
    let subtotal = calculateSubtotal();
    let discountValue = discount ? (discount.value / 100) * subtotal : 0;
    let tcsValue = tcs ? (tcs.value / 100) * subtotal : 0;
    let tdsValue = tds ? (tds.value / 100) * subtotal : 0;
    const cgstAmount = rows.reduce((total, row) => total + (parseFloat(row.cgst_amount) || 0), 0);
    const sgstAmount = rows.reduce((total, row) => total + (parseFloat(row.sgst_amount) || 0), 0);
    const igstAmount = rows.reduce((total, row) => total + (parseFloat(row.igst_amount) || 0), 0);


    // return subtotal - discountValue + parseFloat(adjustment || 0) + tcsValue;
    return subtotal - discountValue + parseFloat(adjustment || 0) + tcsValue + cgstAmount + sgstAmount + igstAmount - tdsValue;
  };







  useEffect(() => {
    if (!isDataLoaded) {

      const para = {
        p_companyid: 1,
      }

      callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
        .then(data => {
          if (data && data.length > 0) {
            setPartyList(data);
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });
    }
  }, [isDataLoaded]);


  useEffect(() => {
    if (!isPONumberLoaded) {
      if (editPurchaseOrderNumber === 0) {
        const para = {
          p_companyid: 1,
          p_modeid: 0,
        }

        callApi(API_ENDPOINTS.PURCHASE_ORDER_GET_PO_NUMBER, 'POST', { 'Content-Type': 'application/json' }, para)
          .then(data => {
            if (data && data.length > 0) {
              setPONumber(data[0].po_number);
            }
          })
          .catch(error => {
            callError('error', error.message, 'Error');
          });
      }
    }
  }, [isPONumberLoaded]);



  const handleDeliveryAddressChange = (event) => {
    setSelectedValue(event.target.value);
  };



  const handleSaveAndDraft = () => {

    const modifiedRows = rows.map(({ product, account, ...rest }) => rest);

    let isValid = true;
    let msg = '';
    let mode_id = 0;
    if (editPurchaseOrderNumber != 0) {
      mode_id = 1;
    }

    if (!tdsID) {
      msg = 'Please Select TDS value'
      isValid = false;
    }
    // if (!discountID) {
    //   msg = 'Please Select Discount value'
    //   isValid = false;
    // }
    if (freight === '') {
      msg = 'Please Select Freight value'
      isValid = false;
    }
    if (!paymentTermsID) {
      msg = 'Please Select Payment Term value'
      isValid = false;
    }

    if (isValid) {

      const requestBody = {
        p_companyid: localStorage.getItem('companyid'),
        p_modeid: mode_id,
        p_partyid: selectedPartyID,
        p_po_number: poNumber,
        p_reference_number: referenceNumber,
        p_date: dayjs(orderFromDate).format('YYYY-MM-DD hh:mm:ss'),
        p_delivery_date: dayjs(expectedDeliveryDate).format('YYYY-MM-DD hh:mm:ss'),
        p_payment_termid: paymentTermsID,
        p_customer_notes: customerNotes,
        p_shipment_reference: shipmentReferenceNumber,
        p_product_list: modifiedRows,

        p_sub_total: subTotal,
        p_discountid: discountID,
        p_discount_value: dDiscount,
        p_tcsid: tcsID,
        p_tcs: dTCS,
        p_tdsid: tdsID,
        p_tds: dTDS,
        p_adjustment: dadjustment,
        p_terms_conditions: termsConditions,
        p_grand_total: grandTotal,
        p_id_enquiry: selectedVendoIdListID,
        p_vendor_quotation_list: vendor_details,
        p_cgst: dCGST,
        p_sgst: dSGST,
        p_fright: freight,
        p_cgst_percentage: cgst,
        p_sgst_percentage: sgst,

      }

      callApi(API_ENDPOINTS.PURCHASE_ORDER_ADD_PURCHASE_ORDER, 'POST', { 'Content-Type': 'application/json' }, requestBody)
        .then(data => {
          if (data && data.length > 0) {
            let message = editPurchaseOrderNumber !== 0 ? 'Purchase Order updated Successfully' : 'New Purchase Order Created Successfully';
            callError('info', message, 'info');
            setDisableSaveBtn(true);
          }
          else {
            callError('error', 'Unable to complete process', 'info');
          }
        })
        .catch(error => {
          callError('error', error.message, 'Error');
        });

    }
    else {
      callError('warning', msg, 'Warning');
    }
  };



  const handlecallbackOrder = () => {
    setViewPurchaseOrder(true);
    setViewPurchaseReceive(false);
  }

  const handlecallProcess = (buttonName) => {
    if (buttonName === 'Receive') {
      setViewPurchaseOrder(false);
      setViewPurchaseBill(false);
      setViewPurchaseReport(false);
      setViewPurchaseReceive(true);

    }
    else if (buttonName === 'Bill') {
      setViewPurchaseOrder(false);
      setViewPurchaseReceive(false);
      setViewPurchaseReport(false);
      setViewPurchaseBill(true);
    }
    else if (buttonName === 'PDF') {





      const updatedPOData = {
        ...allPOData,
        supplier: vendorDetails

      }
      setAllPOData(updatedPOData);
      // }
      generatePDF();
    }
    else if (buttonName === 'Email') {
      setOpenPreviewModal(true);
    }
    else if (buttonName === 'edit') {
      callbackPdf();
    }
    else if (buttonName === 'timeline') {
      setOpen(true);
    }


  };

  const handleSendEmail = async (to, cc) => {
    try {
      const response = await callApi(API_ENDPOINTS.SEND_EMAIL, 'POST', { 'Content-Type': 'application/json' }, {
        to,
        cc,
        subject: `Purchase Order ${allPOData.purchaseOrderNumber}`,
        body: JSON.stringify(allPOData) // This could be formatted as HTML for better presentation
      });

      if (response.success) {
        alert('Email sent successfully');
      } else {
        alert('Failed to send email');
      }
    } catch (error) {
      callError('error', error.message, 'Error');
    }
  };





  const generatePDF = () => {
    setViewPurchaseOrder(false);
    setViewPurchaseReceive(false);
    setViewPurchaseBill(false);
    setViewPurchaseReport(true);

    // const doc = new jsPDF({
    //   format: 'a4',
    //   unit: 'pt'
    // });

    // doc.html(reportRef.current, {
    //   callback: function (doc) {
    //     doc.save('purchase_order_report.pdf');
    //   },
    //   x: 10,
    //   y: 10,
    //   width: 575, // A4 page width - margins
    //   windowWidth: 800, // The window width to use for rendering
    // });
  };



  const callbackPdf = () => {
    setViewPurchaseOrder(true);
    setViewPurchaseReceive(false);
    setViewPurchaseReport(false);
  }




  const handleFilesSelected = (selectedFiles) => {
    setFiles(selectedFiles);
  };

  const handleFileCountChanged = (count) => {
    setFileCount(count);
  };



  const timelineData = [
    {
      time: "09:00 AM",
      icon: "shopping_cart",
      description: "Purchase Order Created",
      user: "Anita Sharma",
      date: "May 20, 2025",
    },
    {
      time: "10:15 AM",
      icon: "note",
      description: "Note added - vendor confirmed availability",
      user: "Rajiv Menon",
      date: "May 20, 2025",
    },
    {
      time: "11:30 AM",
      icon: "edit",
      description: "Status updated from Created to Pending Approval",
      user: "Rajiv Menon",
      date: "May 20, 2025",
    },
    {
      time: "03:45 PM",
      icon: "edit",
      description: "Status updated from Pending Approval to Approved",
      user: "Anita Sharma",
      date: "May 20, 2025",
    },
    {
      time: "04:10 PM",
      icon: "note",
      description: "Note added - PO sent to supplier via email",
      user: "Anita Sharma",
      date: "May 20, 2025",
    },
    {
      time: "09:00 AM",
      icon: "edit",
      description: "Delivery Date updated to May 25, 2025",
      user: "Rajiv Menon",
      date: "May 21, 2025",
    },
  ];


  const [inputValue, setInputValue] = useState('');

  return (<>

    {viewPurchaseOrder && (
      <Box padding={0}>

        {/* <Header title='New Purchase Order' subtitle="" callback={callback} /> */}
        <Header title={editPurchaseOrderNumber === 0 ? 'New Purchase Order' : 'Edit Purchase Order'} subtitle="" callback={callback} />
        <Divider />
        {editPurchaseOrderNumber > 0 && (
          <>
            <PurchaseActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
            <Divider />
          </>
        )}
        <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
          setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
          setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            px: 1,
            py: 1
          }}
        >
          <Typography variant="h6"  >
            <span style={{ color: 'red' }}>*</span> Mandatory fields
          </Typography>
        </Box>

        <ResponsiveBox customMaxHeight={{
          xs: '72vh', // Extra small devices (phones)
          sm: '72vh', // Small devices (tablets)
          md: '74vh', // Medium devices (small laptops)
          lg: '75vh', // Large devices (desktops)
          xl: '81vh', // Extra large devices (large desktops)
        }}>

          <Grid container  >

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >

              <Grid container padding="10px 0px 10px 20px" sx={{ backgroundColor: colors.primary[400] }} spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center" >

                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Party Name <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={6} xl={4}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={partyList.filter(p => p && typeof p === 'object' && p.companyname)}
                    value={partyList.find(p => p?.id === selectedParty?.id) || null}
                    onChange={(event, newValue) => {
                      setSelectedParty(newValue);
                      setSelectedPartyID(newValue?.id || null);
                    }}
                    getOptionLabel={(option) =>
                      (option && typeof option === 'object' && option.companyname)
                        ? option.companyname
                        : ''
                    }
                    filterOptions={(options, state) => {
                      return filter(
                        options.filter(p => p && typeof p === 'object' && typeof p.companyname === 'string'),
                        state
                      );
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="" required variant="outlined" />
                    )}
                    renderOption={(props, option) => (
                      <Box sx={{ backgroundColor: colors.primary[400] }} component="li" {...props} display="flex" alignItems="center">
                        <Avatar src={option.avatarUrl} alt={option.companyname} sx={{ marginRight: 2 }} />
                        <Box display="flex" flexDirection="column">
                          <Typography variant="subtitle2" component="div">
                            {option.companyname}
                          </Typography>
                          <Box display="flex" justifyContent="space-between" width="100%">
                            <Box display="flex" alignItems="center">
                              <EmailIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                              <Typography variant="body2" color="textSecondary">
                                {option.email}
                              </Typography>
                            </Box>
                            <Divider orientation="vertical" flexItem sx={{ marginX: 1 }} />
                            <Box display="flex" alignItems="center">
                              <BusinessIcon fontSize="small" sx={{ marginRight: 0.5 }} />
                              <Typography variant="body2" color="textSecondary">
                                {option.name}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left" >
                    Delivery Address <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <FormControl component="fieldset">
                    <RadioGroup row value={selectedValue} onChange={handleDeliveryAddressChange}>
                      <FormControlLabel
                        value="warehouses"
                        control={<Radio size="small" color="secondary" />}
                        label="Warehouses"
                      />
                      <FormControlLabel
                        value="customer"
                        control={<Radio size="small" color="secondary" />}
                        label="Customer"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>


            <Grid item xs={12} xl={12} >
              <Grid container padding="20px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                <Grid item xs={12} sm={12} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center">
                  <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Purchase Order # <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <TextField value={poNumber} fullWidth size="small" label="" required variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <CustomTooltip
                            title={
                              <span>
                                <b>click here to enable or disable auto generation of purchase order number.</b> <br />
                              </span>}
                          >
                            <SettingsIcon style={{ fontSize: "20px" }} />
                          </CustomTooltip>

                        </InputAdornment>
                      ),
                    }} />
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Reference #
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <TextField value={referenceNumber} onChange={(e) => setReferenceNumber(e.target.value)} fullWidth size="small" label="" required variant="outlined" />
                </Grid>

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Purchase Indent #
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <TextField value={referenceNumber} onChange={(e) => setReferenceNumber(e.target.value)} fullWidth size="small" label="" required variant="outlined" />
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Date
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={2}>
                      <DatePicker
                        size="small"
                        id="Orderdate"
                        value={dayjs(orderFromDate)}
                        onChange={(date) => setOrderFromDate(date)}
                        slotProps={{ textField: { size: 'small' } }}
                        fullWidth
       format="DD-MMM-YYYY"
                        className="customDatePicker"
                        renderInput={(props) => (
                          <TextField required {...props} />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider> */}

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={2}>
                      <DatePicker
                        size="small"
                        id="Orderdate"
                        value={orderFromDate ? dayjs(orderFromDate) : null}
                        onChange={(date) => setOrderFromDate(date)}
                        slotProps={{ textField: { size: 'small' } }}
                        fullWidth
                        format="DD-MMM-YYYY"
                        className="customDatePicker"
                      />
                    </Stack>
                  </LocalizationProvider>

                </Grid>

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Fright <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    options={['To Pay', 'Paid']}
                    value={freight}
                    onChange={(event, newValue) => {
                      setFreight(newValue ?? null); // fallback to null if needed
                    }}

                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Freight Option"
                        variant="outlined"
                      />
                    )}

                  />
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Expected Delivery Date
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>



                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Stack spacing={2}>
                      <DatePicker
                        size="small"
                        id="Orderdate"
                        value={
                          dayjs(expectedDeliveryDate).isValid()
                            ? dayjs(expectedDeliveryDate)
                            : null
                        }
                        onChange={(date) => setExpectedDeliveryDate(date)}
                        slotProps={{ textField: { size: 'small' } }}
                        fullWidth
                        format="DD-MMM-YYYY"
                        className="customDatePicker"
                      />
                    </Stack>
                  </LocalizationProvider>

                </Grid>
                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Payment Terms <span style={{ color: '#d32f2f', fontWeight: 600 }}>*</span>
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3} lg={2.8} xl={1.5}>
                  <CustomAutocomplete
                    label="Payment Term"
                    options={paymentTerms}
                    selectedOption={selectedPaymentTerm}
                    setSelectedOption={setSelectedPaymentTerm}
                    setAnchorEl={setPaymentTermAnchorEl}
                    anchorEl={paymentTermAnchorEl}
                    handleOpenMenu={handleOpenMenu(setPaymentTermAnchorEl)}
                    handleCloseMenu={handleCloseMenu(setPaymentTermAnchorEl)}
                    filterText={paymentTermFilterText}
                    setFilterText={setPaymentTermFilterText}
                    handleSelectOption={handleSelectOption(setSelectedPaymentTerm, setPaymentTermsID)}
                    handleAddOption={handleAddOption('Payment Term')}
                    selectedID={paymentTermsID}
                    setSelectedID={setPaymentTermsID}
                    isRequired={true}
                  />

                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 5, xl: 5 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={1.6} lg={2} xl={1.5} display="flex-start" justifyContent="center" >
                  <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                    Shipment Preference
                  </Typography>
                </Grid>

                <Grid item xs={12} sm={11} md={3.8} lg={2.8} xl={2.5}>
                  <TextField value={shipmentReferenceNumber} onChange={(e) => setShipmentReferenceNumber(e.target.value)} fullWidth size="small" label="" required variant="outlined" />
                </Grid>

              </Grid>
            </Grid>

            <Grid item xs={12} xl={12} mt={5} >
              <Divider />
            </Grid>

            <Grid item xs={12} md={12} lg={11.8} xl={11.8} >
              <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

                <Grid item xs={12} sm={11} md={12} lg={12} xl={12} display="flex-start" justifyContent="center" >
                  <CustomTableContainer colors={colors}>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Product</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'center' }}>Account</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Quantity</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Rate</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Amount</TableCell>
                            <TableCell colSpan={2} align="center" sx={{ fontWeight: 'bold', padding: 10, }}>CGST</TableCell>
                            <TableCell colSpan={2} align="center" sx={{ fontWeight: 'bold', padding: 10, }}>SGST</TableCell>
                            <TableCell colSpan={2} align="center" sx={{ fontWeight: 'bold', padding: 10, }}>IGST</TableCell>
                            <TableCell style={{ size: "small", fontSize: '14px', padding: 10, textAlign: 'right' }}>Total</TableCell>
                          </TableRow>
                        </TableHead>


                        <TableBody>
                          {rows.map((row, index) => (
                            <TableRow key={index}>


                              <TableCell style={{ size: "small", minWidth: "200px", border: '1px solid black', fontSize: '12px', padding: '10px' }}>
                                <Box display="flex" justifyContent="space-between">
                                  <Box sx={{ width: '100%' }}>
                                    {row.product ? (
                                      <>
                                        <Typography fontWeight="bold">{row.product.description}</Typography>
                                        <Typography variant="caption" color="text.secondary">
                                          SKU: {row.product.code}
                                        </Typography>


                                      </>
                                    ) : (
                                      <Autocomplete
                                        size="small"
                                        fullWidth
                                        disablePortal={true} // ✅ keep dropdown inside table
                                        options={products}
                                        value={row.product}
                                        onChange={(e, newValue) => handleProductChange(index, newValue)}
                                        getOptionLabel={(option) =>
                                          option && typeof option === 'object'
                                            ? `${option.description} (SKU: ${option.code})`
                                            : ''
                                        }
                                        renderOption={(props, option) => (
                                          <Box component="li" {...props} sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography fontWeight="bold">{option.description}</Typography>
                                            <Typography variant="caption" color="text.secondary">
                                              SKU: {option.code} | Purchase Rate: ₹{option.rate || 100}
                                            </Typography>
                                            <Typography variant="caption" color="text.disabled">
                                              Stock on Hand: {option.stockOnHand || 500}
                                            </Typography>
                                          </Box>
                                        )}
                                        PopperProps={{
                                          modifiers: [
                                            {
                                              name: 'preventOverflow',
                                              options: {
                                                boundary: 'viewport',
                                              },
                                            },
                                          ],
                                          sx: {
                                            zIndex: 1500,
                                          },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Type or select a product"
                                            size="small"
                                          />
                                        )}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "200px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <Autocomplete
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiSelect-select': {
                                      padding: '8px',
                                    },
                                  }}
                                  options={purchaseAccounts}
                                  value={row.account}
                                  getOptionLabel={(option) => option.description}
                                  onChange={(event, newValue) => handleAccountChange(index, newValue)}
                                  renderInput={(params) => (
                                    <TextField
                                      fullWidth
                                      {...params}
                                      placeholder="Select an account"

                                      variant="outlined"
                                    />
                                  )}
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "150px", border: '1px solid black', fontSize: '12px', padding: 10, textAlign: 'right' }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  variant="outlined"
                                  type="number"
                                  value={row.quantity}
                                  onChange={(e) => handleQuantityChange(index, e.target.value)}
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "100px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  type="number"
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}

                                  variant="outlined"

                                  value={row.rate}
                                  onChange={(e) => handleRateChange(index, e.target.value)}
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "150px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  value={row.amount}
                                  variant="outlined"
                                  disabled
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "60px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  size="small"
                                  type="number"
                                  value={row.cgst_rate}
                                  onChange={(e) => handleTaxRateChange(index, 'cgst_rate', e.target.value)}
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}

                                  variant="outlined"
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "100px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  size="small"
                                  type="number"
                                  value={row.cgst_amount}
                                  disabled
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}

                                  variant="outlined"
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "60px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  size="small"
                                  type="number"
                                  value={row.sgst_rate}
                                  onChange={(e) => handleTaxRateChange(index, 'sgst_rate', e.target.value)}
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}

                                  variant="outlined"
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "100px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  size="small"
                                  type="number"
                                  value={row.sgst_amount}
                                  disabled
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}

                                  variant="outlined"
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "60px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  size="small"
                                  type="number"
                                  value={row.igst_rate}
                                  onChange={(e) => handleTaxRateChange(index, 'igst_rate', e.target.value)}
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}

                                  variant="outlined"
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "100px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  size="small"
                                  value={row.igst_amount}
                                  type="number"
                                  disabled
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}

                                  variant="outlined"
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", minWidth: "200px", border: '1px solid black', fontSize: '12px', padding: 0 }}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none',
                                    },
                                    '& .MuiInputBase-input': {
                                      padding: '8px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  value={row.total}
                                  variant="outlined"
                                  disabled
                                />
                              </TableCell>

                              <TableCell style={{ size: "small", border: '0px solid transparent', fontSize: '12px', padding: 0 }}>
                                <IconButton onClick={() => removeRow(index)} color="secondary">
                                  <HighlightOffOutlinedIcon sx={{ color: '#ef5350', fontSize: "16px" }} />
                                </IconButton>
                              </TableCell>

                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <Box mt={2}>
                        <Button
                          size="small"
                          variant="contained"
                          color="secondary"
                          sx={{ textTransform: "none" }}
                          startIcon={<AddCircleOutline />}
                          onClick={handleAddRow}
                        >
                          Add New Row
                        </Button>
                      </Box>
                    </TableContainer>
                  </CustomTableContainer>

                </Grid>
              </Grid>
            </Grid>


            <Grid item xs={12} lg={12} xl={12} mt={0} padding={2} >

              <Box padding={1} sx={{
                display: 'flex',
                alignItems: 'center',
                borderColor: 'divider',
                borderRadius: 2,
                color: 'text.secondary', '& svg': { m: 1, },
              }} >
                <Grid container spacing={0}>
                  <Grid item xs={6} lg={6.4} xl={8.1} marginRight={1}>
                    <Typography variant="h5" fontWeight="bold">Customer Notes</Typography>
                    <Grid item xs={12} lg={12} xl={10}>
                      <TextField
                        id="outlined-multiline-static"
                        value={customerNotes}
                        onChange={(e) => setCustomerNotes(e.target.value)}
                        placeholder="Enter the customer notes , will appear the purchase order."
                        multiline
                        rows={4} // Adjust the number of rows as needed
                        fullWidth // Optional: makes the text area take full width
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <Grid item xs={10} md={6} lg={5.5} xl={3.6}  >
                    <Box p={2} sx={{ backgroundColor: colors.primary[400], borderRadius: "10px" }}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography marginLeft="12px" variant="h5" fontWeight="bold">Subtotal</Typography>
                          <Typography marginLeft="12px" fontSize="12px" >Total Quantity : {calculateTotalQuantity()}</Typography>
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold"> {calculateSubtotal().toFixed(2)}</Typography>
                        </Grid>

                        <Grid item xs={6} justifyContent="flex-start">




                          <Autocomplete
                            size="small"
                            fullWidth
                            freeSolo
                            options={discounts}
                            value={discount}
                            inputValue={inputValue}
                            sx={{
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                              '& .MuiSelect-select': {
                                padding: '0px',
                              },
                            }}
                            onInputChange={(event, newInputValue) => {

                              const regex = /^\d*\.?\d*%?$/;
                              if (regex.test(newInputValue)) {
                                setInputValue(newInputValue);
                              }
                            }}
                            getOptionLabel={(option) => {
                              if (typeof option === 'string') return option;
                              if (typeof option === 'object' && option !== null) return option.description || '';
                              return '';
                            }}
                            onChange={(event, newValue) => {
                              if (typeof newValue === 'string') {
                                setDiscount({ id: null, description: newValue });
                                setDiscountID(null);
                                setInputValue(newValue); // keep inputValue in sync
                              } else if (newValue && typeof newValue === 'object') {
                                setDiscount(newValue);
                                setDiscountID(newValue.id);
                                setInputValue(newValue.description); // sync with selected object
                              } else {
                                setDiscount(null);
                                setDiscountID(null);
                                setInputValue('');
                              }
                            }}
                            onBlur={(e) => {
                              if (inputValue?.trim()) {
                                const cleanedValue = inputValue.trim().replace(/%$/, ''); // remove trailing %
                                setDiscount({ id: null, description: inputValue, value: parseFloat(cleanedValue) });
                                setDiscountID(null);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Discount"
                                variant="outlined"
                                fullWidth
                              />
                            )}
                          />


                        </Grid>

                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold"> {dDiscount.toFixed(2)}</Typography>
                        </Grid>

                        <Grid item xs={6}>
                          <TextField
                            size="small"
                            fullWidth
                            sx={{
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                              '& .MuiSelect-select': {
                                padding: '0px',
                              },
                            }}
                            label="Adjustment"
                            variant="outlined"
                            type="number"
                            value={adjustment}
                            onChange={(e) => setAdjustment(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold"> {dadjustment}</Typography>
                        </Grid>



                        {/* TDS */}
                        <Grid item xs={10} container justifyContent="flex-end">
                          <Autocomplete
                            size="small"
                            fullWidth
                            sx={{
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                              },
                              '& .MuiSelect-select': {
                                padding: '0px',
                              },
                            }}
                            options={tdsOptions} // You need to define this array like discounts/tcsOptions
                            value={tds}
                            getOptionLabel={(option) => option.description}
                            onChange={(event, newValue) => {
                              setTds(newValue);
                              setTDSID(newValue.id); // Optional
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="TDS"
                                variant="outlined"
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={2} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold">
                            {dTDS.toFixed(2)}
                          </Typography>
                        </Grid>

                        {/* CGST */}
                        <Grid item xs={6}>
                          <Typography marginLeft="12px" fontSize="12px">Add: CGST</Typography>
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold">
                            {calculateCgstTotal().toFixed(2)}
                          </Typography>
                        </Grid>

                        {/* SGST */}
                        <Grid item xs={6}>
                          <Typography marginLeft="12px" fontSize="12px">Add: SGST</Typography>
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold">
                            {calculateSgstTotal().toFixed(2)}
                          </Typography>
                        </Grid>

                        {/* IGST */}
                        <Grid item xs={6}>
                          <Typography marginLeft="12px" fontSize="12px">Add: IGST</Typography>
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end">
                          <Typography variant="body1" fontWeight="bold">
                            {calculateIgstTotal().toFixed(2)}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} container justifyContent="flex-end">
                          <Typography variant="h5">Total : {calculateTotal().toFixed(2)}</Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>


                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} xl={12} mt={3} padding={2} >

              <Box padding={2} sx={{
                display: 'flex',
                backgroundColor: colors.primary[400],
                alignItems: 'center',
                //  border: '1px solid black',
                borderColor: 'divider',
                borderRadius: 2,
                // bgcolor: 'background.paper',
                color: 'text.secondary',
                '& svg': {
                  m: 1,
                },
              }} >
                <Grid container spacing={2}>
                  <Grid item xs={6} xl={6} marginRight={2}>
                    <Typography variant="h5" fontWeight="bold">Terms & Conditions</Typography>
                    <TextField value={termsConditions} onChange={(e) => setTermsConditions(e.target.value)} type="text" multiline fullWidth placeholder="Enter the Terms And Condition for the purchase order. " />
                  </Grid>
                  <Divider orientation="vertical" marginLeft="10px" variant="middle" flexItem />
                  <Grid item xl={4}>
                    <Typography variant="body1" fontWeight="bold">Attache File(s) to Purchase Order</Typography>

                    <FileUploadButton onFilesSelected={handleFilesSelected} onFileCountChanged={handleFileCountChanged} />

                    <Typography marginTop={1} variant="body1" fontWeight="bold"> {fileCount > 0 && (
                      <div>
                        {fileCount} file{fileCount > 1 ? 's' : ''} selected
                      </div>
                    )}</Typography>


                  </Grid>

                </Grid>
              </Box>
            </Grid>

          </Grid>
        </ResponsiveBox>




        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <Box position="fixed" sx={{ top: 'auto', bottom: 0, backgroundColor: "transparent" }}>

              <Toolbar>
                <Button size="small" variant="contained" color="secondary" disabled={disableSaveBtn} onClick={handleSaveAndDraft} startIcon={<SaveAltOutlined />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Save PO</Button>
                {/* <Button  size="small" variant="contained" color="secondary" startIcon={<SendOutlinedIcon />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Save And Send</Button> */}
                <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
              </Toolbar>
            </Box>
          </Grid>
        </Grid>

        {/* <PaymentTermForm open={isPaymentTermDialogOpen} onClose={() => setPaymentTermDialogOpen(false)} terms={paymentTerms} setTerms={setPaymentTerms} /> */}
        <AddPaymentTerms onClose={() => setPaymentTermDialogOpen(false)} open={isPaymentTermDialogOpen} />
      </Box>
    )}

    {viewPurchaseReceive && (
      <AddNewPurchaseReceive handlecallback={handlecallbackOrder} editPurchaseOrderNumber={editPurchaseOrderNumber} editPurchaseReceiveNumber={0} editPurchaseReceiveID={0} />
    )}
    {/* editPurchaseReceiveNumber={0} editPurchaseReceiveID={0} */}
    {viewPurchaseBill && (
      <AddNewPurchaseBills handlecallback={handlecallbackOrder} editPurchaseOrderNumber={editPurchaseOrderNumber} />
      // <PurchaseOrderTimeline events={timelineData} />

    )}

    {viewPurchaseReport && (
      <Box padding={0}>
        <Header title={poNumber} subtitle="" callback={callbackPdf} />
        <Divider />
        {editPurchaseOrderNumber > 0 && (
          <>
            <PurchaseActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} />
            <Divider />
          </>
        )}
        <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
          setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
          setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

        <ResponsiveBox
          customMaxHeight={{
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '74vh', // Medium devices (small laptops)
            lg: '74vh', // Large devices (desktops)
            xl: '82vh', // Extra large devices (large desktops)
          }}>

          <Box padding={1}>
            {/* <PurchaseOrderPDF poData={allPOData} /> */}
            <HorizonPO poData={allPOData} />
          </Box>

        </ResponsiveBox>
      </Box>
    )}


    <PreviewEmailModal
      open={openPreviewModal}
      onClose={() => setOpenPreviewModal(false)}
      onSend={handleSendEmail}
      poData={allPOData}
    />

    <Box sx={{ p: 2 }}>

      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{ sx: { width: 400, p: 2, backgroundColor: colors.primary[500] } }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Purchase Order Timeline
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <PurchaseOrderTimeline events={timelineData} />
      </Drawer>
    </Box>
  </>)
}
export default AddNewPurchaseOrder;